// Helpers DOM partagés.

export function $( id ) { return document.getElementById( id ); }

export function $$( sel, ctx ) { return ( ctx || document ).querySelectorAll( sel ); }

export function clearE( id ) {
	var el = $( id );
	if ( el ) el.classList.remove( 'err' );
}

export function debounce( fn, ms ) {
	var t = null;
	return function () {
		var args = arguments, ctx = this;
		clearTimeout( t );
		t = setTimeout( function () { fn.apply( ctx, args ); }, ms );
	};
}
